import {EntityFactory} from '@modifi/redux'
import {routerActions} from '@modifi/router'
import {createSelector} from 'reselect'
import {
  getAuthenticatedAdminAresClient,
  getAuthenticatedAdminApolloClient,
} from '@modifi/trade-api-clients'

const apiClient = getAuthenticatedAdminAresClient()

const {actions, selectors, reducer, actionTypes} = EntityFactory({
  actionNamePrefix: 'data/transaction/entity',
  rootSelector: state => state?.data?.transaction?.entity,
  actionMiddleware: {
    successAction: (next, payload, opId) => dispatch => {
      const {processedOn} = payload
      // redirect if transaction is already processed
      if (processedOn) {
        dispatch(routerActions.replace('/'))
      }
      dispatch(next(payload, opId))
    },
  },
  fetchRequest: (state, {transactionId}) =>
    apiClient.BankTransactions.byId({transactionId}).then(response => response.data()),
})

export default reducer

export const TransactionEntityActionTypes = actionTypes

export const {
  selectIsLoading: selectIsTransactionFetchLoading,
  selectIsError: selectTransactionFetchError,
  selectErrorMessage: selectTransactionErrorMessage,
  selectEntity: selectTransaction,
} = selectors

export const selectTransactionId = createSelector(selectTransaction, transaction => transaction?.id)

export const selectTransactionAmount = createSelector(
  selectTransaction,
  transaction => transaction?.amount
)

export const selectTransactionCurrency = createSelector(
  selectTransaction,
  transaction => transaction?.currency
)

export const aFetchTransaction = transactionId => actions.fetch({transactionId})

export const aUpdateTransaction = (transaction, merge = true) => actions.update(transaction, merge)

export const aClearTransaction = actions.clear

// action to open a file
export const aOpenFile = fileId => () => {
  const apiApolloClient = getAuthenticatedAdminApolloClient()
  return apiApolloClient.Documents.fetch({fileId})
    .then(response => {
      const blob = response.responseData
      const fileURL = URL.createObjectURL(blob)
      const newTab = window.open(fileURL)

      return {
        status: !(!newTab || newTab.closed || typeof newTab.closed === 'undefined')
          ? 'success'
          : 'failed', // permission denied to open new tab
      }
    })
    .catch(() => ({status: 'failed'}))
}
